<template>
  <VFlex xs12>
    <VTextField
      v-model.trim="search"
      :label="$t('form.search')"
      prepend-icon="search"
      solo
      clearable
      required
      class="mb-3"
      @keyup.enter="find"
    />
    <VDataTable
      v-model="selected"
      :headers="headers"
      :items="items"
      :class="{blured:!items.length}"
      :no-data-text="$t('table.no_data_text')"
      :no-results-text="$t('table.no_results_text')"
      item-key="username"
    >
      <template
        slot="headerCell"
        slot-scope="props"
      >
        <VTooltip bottom>
          <span slot="activator">
            {{ props.header.text }}
          </span>
          <span>
            {{ props.header.text }}
          </span>
        </VTooltip>
      </template>
      <template
        slot="items"
        slot-scope="props"
      >
        <tr>
          <td>
            <VBtn
              icon
              @click="impersonateUser(props.item)"
            >
              <VAvatar
                class="indigo"
                size="32px"
              >
                <VGravatar
                  v-if="props.item.email"
                  :email="props.item.email"
                  :alt="props.item.email"
                  :size="32"
                  default-img="mm"
                />
              </VAvatar>
            </VBtn>
          </td>
          <td>{{ props.item.username }}</td>
          <td class="text-xs-right">
            {{ props.item.email || '---' }}
          </td>
        </tr>
      </template>
    </VDataTable>
  </VFlex>
</template>

<script>
import UserApi from '@/api/user';

export default {
  name: 'List',
  data() {
    return {
      search: '',
      pagination: {},
      selected: [],
      headers: [
        { text: this.$i18n.t('table.gogol'), align: 'left', sortable: false },
        {
          text: this.$i18n.t('table.username'),
          align: 'left',
          sortable: false,
          value: 'username',
        },
        { text: this.$i18n.t('table.email'), value: 'email' },
      ],
      items: [],
    };
  },
  computed: {
    pages() {
      return this.pagination.rowsPerPage
        ? Math.ceil(this.items.length / this.pagination.rowsPerPage)
        : 0;
    },
  },
  async created() {
    if (this.$auth.canImpersonate()) {
      this.items = await UserApi.list();
    }
  },
  methods: {
    impersonateUser(person) {
      if (!this.$auth.canImpersonate()) {
        this.$notify({
          text: this.$i18n.t('error.cannot_impersonate'),
          group: 'all',
          type: 'error',
        });
        return;
      }
      this.$store.commit('user/SET_IMPERSONATE', person);
      this.$notify({
        type: 'success',
        group: 'all',
        text: this.$i18n.t('success.impersonated', { name: person.username }),
      });
    },
    async find() {
      try {
        this.items = await UserApi.find(this.search);
      } catch (error) {
        this.$errorHandler.handle(error);
      }
    },
  },
};
</script>
